// extracted by mini-css-extract-plugin
export default {"error-wrap":"q5XGj","error-icon":"VOFXM"};